import { Typography, styled } from '@mui/material'
import { COLORS } from '../../styles/colors'

export const TypographyPrimary16Bold = styled(Typography)(theme => ({
	fontWeight: 600,
	fontSize: '16px',
	lineHeight: '20px',
	color: COLORS.black,
}))
